import lodash from "lodash";
import { StoreFrontEnums } from "StoreFront/Common/Constants/Enums";
import * as purchaseModes from "../constants/purchaseModes";
import purchaseModeGrouping from "../../configs/purchaseModeGrouping.json";
import { PurchaseModeOffer } from "../../summary/PurchaseMode/helpers/PurchaseModeOffer";
import { Discount, InstallmentsDiscount } from "../../campaigns/helpers";
import * as resourceKeys from "./resources";

const offerPriceRelEnum = StoreFrontEnums.PRICE_RESOURCE_KEYS;

const priceResourceKeys = StoreFrontEnums.PRICE_RESOURCE_KEYS;

const CURRENCY_SYMBOL = "€";
const LOCALE_DECIMAL_SEPARATOR = ",";
const DEFAULT_ECMA_DECIMAL_SEPARATOR = ".";
const ZERO = 0;
const ZERO_CROSS = "€--";
const ZERO_PER_MONTH = 0;
const TARIFF_TITLE_IDENTIFIER = "Tarifário";

export const DEFAULT = {
	currencySymbol: CURRENCY_SYMBOL,
	decimalSeparator: LOCALE_DECIMAL_SEPARATOR,
	zero: ZERO,
	noDecimals: 0,
	decimals: 2,
	hideCurrencyOnZero: false
};

export const ALWAYS_TWO_DECIMALS_NO_CURRENCY = {
	currencySymbol: "",
	decimalSeparator: LOCALE_DECIMAL_SEPARATOR,
	zero: ZERO,
	noDecimals: 2,
	decimals: 2,
	hideCurrencyOnZero: false
};

export const ALWAYS_TWO_DECIMALS = {
	currencySymbol: CURRENCY_SYMBOL,
	decimalSeparator: LOCALE_DECIMAL_SEPARATOR,
	zero: ZERO,
	noDecimals: 2,
	decimals: 2,
	hideCurrencyOnZero: false
};

export const ALWAYS_TWO_DECIMALS_ZERO_CROSSED = {
	currencySymbol: CURRENCY_SYMBOL,
	decimalSeparator: LOCALE_DECIMAL_SEPARATOR,
	zero: ZERO_CROSS,
	noDecimals: 2,
	decimals: 2,
	hideCurrencyOnZero: true
};

export const DEFAULT_ZERO_CROSSED = lodash.assign({}, DEFAULT, {
	zero: ZERO_CROSS,
	hideCurrencyOnZero: true
});

export class PriceOffer {
	constructor({ priceOffer, resources = null }) {
		for (const prop in priceOffer) {
			this[prop] = priceOffer[prop];
		}
		this.discount = new Discount({ priceOffer, resources });
		this.resources = resources;
	}

	formatPrice(value, config = null) {
		return getFormattedRoundedPrice(value, config, this.resources);
	}

	getDiscount() {
		this.discount;
	}

	getPreviousPrice() {
		return this.price;
	}

	getPrice() {
		return this.campaignValue;
	}

	isZeroPriced() {
		return this.campaignValue == 0;
	}

	isValidPreviousPrice() {
		return isValidPreviousPrice(this.getPreviousPrice(), this.getPrice());
	}

	getStandardPrice() {
		return this.formatPrice(this.getPrice());
	}

	getStandardPreviousPrice() {
		return this.formatPrice(this.getPreviousPrice());
	}

	formatSummaryTotalValue(value) {
		return this.formatPrice(value, ALWAYS_TWO_DECIMALS);
	}

	getSummaryTotalPrice() {
		return this.formatSummaryTotalValue(this.getPrice());
	}

	getSummaryTotalPreviousPrice() {
		return this.formatPrice(this.getPreviousPrice(), ALWAYS_TWO_DECIMALS);
	}

	getStandardMonthlyPrice() {
		throw new Error("Not Implemented");
	}

	getSummaryTotalMonthlyPrice() {
		throw new Error("Not Implemented");
	}

	getStandardFirstInstallmentPrice() {
		throw new Error("Not Implemented");
	}

	getSummaryTotalFirstInstallmentPrice() {
		throw new Error("Not Implemented");
	}

	getSummaryAllValue() {
		throw new Error("Not Implemented");
	}
}

export class PromptPayment extends PriceOffer {
	constructor({ priceOffer, resources }) {
		super({ priceOffer, resources });
	}

	getStandardPrice() {
		return this.formatPrice(this.getPrice(), DEFAULT_ZERO_CROSSED);
	}

	getStandardPreviousPrice() {
		return this.formatPrice(this.getPreviousPrice(), DEFAULT_ZERO_CROSSED);
	}

	formatSummaryTotalValue(value) {
		return this.formatPrice(value, ALWAYS_TWO_DECIMALS_ZERO_CROSSED);
	}

	getSummaryTotalPrice() {
		return this.formatSummaryTotalValue(this.getPrice());
	}

	getSummaryTotalPreviousPrice() {
		return this.formatPrice(
			this.getPreviousPrice(),
			ALWAYS_TWO_DECIMALS_ZERO_CROSSED
		);
	}
}

export class Installments extends PriceOffer {
	constructor({ priceOffer, resources }) {
		super({ priceOffer, resources });

		this.discount = new InstallmentsDiscount({ priceOffer, resources });
	}

	getStandardMonthlyPrice() {
		return this.formatPrice(this.campaignMonthlyValue);
	}

	getSummaryTotalMonthlyPrice() {
		return this.formatSummaryTotalValue(this.campaignMonthlyValue);
	}

	getStandardFirstInstallmentPrice() {
		return this.formatPrice(this.getPrice());
	}

	getSummaryTotalFirstInstallmentPrice() {
		return this.formatSummaryTotalValue(this.getPrice());
	}
}

export class Points extends PriceOffer {
	constructor({ priceOffer, resources }) {
		super({ priceOffer, resources });
	}
}

export class All extends PriceOffer {
	constructor({ priceOffer, resources }) {
		super({ priceOffer, resources });
	}

	getSummaryAllValue() {
		if(this.getPrice() > 0){
			return this.getSummaryTotalPrice()
		}
		if(this.campaignMonthlyValue > 0){
			return this.getSummaryTotalMonthlyPrice()
		}
		if(this.pointsPrice > 0){
			return `${this.pointsPrice} ${
				this.resources[ priceResourceKeys.POINTS_TEXT]
			}`
		}
		return this.getSummaryTotalPrice()
	}
}

const getKeyValueFromResource = (resources, key) =>
	resources && resources[key] && resources[key].toLowerCase();

export function createPriceOffer({ priceOffer, resources }) {
	if (priceOffer.purchaseMode) {
		if (
			priceOffer.purchaseMode === purchaseModes.PROMPT_PAYMENT ||
			priceOffer.purchaseMode ===
				getKeyValueFromResource(resources, offerPriceRelEnum.PROMPTPAYMENT_FILTER)
		) {
			return new PromptPayment({ priceOffer, resources });
		}
		if (
			priceOffer.purchaseMode === purchaseModes.POINTS ||
			priceOffer.purchaseMode ===
				getKeyValueFromResource(resources, offerPriceRelEnum.POINTS_FILTER)
		) {
			return new Points({ priceOffer, resources });
		}
		if (
			priceOffer.purchaseMode === purchaseModes.INSTALLMENTS ||
			priceOffer.purchaseMode ===
				getKeyValueFromResource(resources, offerPriceRelEnum.INSTALLMENT_FILTER)
		) {
			return new Installments({ priceOffer, resources });
		}
		if(
			priceOffer.purchaseMode === purchaseModes.ALL_FILTER ||
			priceOffer.purchaseMode === getKeyValueFromResource(resources, offerPriceRelEnum)
		){
			return new All({ priceOffer, resources });
		}
		return new PriceOffer({ priceOffer, resources });
	}
	console.error(
		"[Create Price Offer]: priceOffer doesn't match any known type... Going to default..."
	);
	return new PriceOffer({ priceOffer, resources });
}

export const getCurrencySymbol = (
	priceValue,
	priceConfig = DEFAULT,
	resources = null
) => {
	let currencySymbol = "";
	if (priceConfig.hideCurrencyOnZero) {
		const isZero = priceValue == 0;
		if (!isZero) {
			currencySymbol = priceConfig.currencySymbol;
		}
	} else {
		currencySymbol = priceConfig.currencySymbol;
	}
	return currencySymbol;
};

export const getFormattedRoundedPrice = (
	priceValue,
	priceConfig = DEFAULT,
	resources = null
) => {
	return `${getCurrencySymbol(
		priceValue,
		priceConfig,
		resources
	)}${getRoundedPrice(priceValue, priceConfig, resources)}`;
};

export const getFormattedPrice = (priceValue, priceConfig = DEFAULT) => {
	return `${getCurrencySymbol(priceValue, priceConfig)}${priceValue}`;
};

export const getFormattedPriceWithNDecimals = (priceValue, nDecimals) => {
	// TODO - RaL - Check if we need to convert this to Locale before send it to RoundedPrice
	const config = ALWAYS_TWO_DECIMALS;

	return config.currencySymbol + getRoundedPrice(priceValue, config);
	// return currencySymbol + "" + priceValue.toLocaleString('pt-PT', { minimumFractionDigits: nDecimals, maximumFractionDigits: nDecimals })
};

export const getRoundedPrice = (
	priceValue,
	priceConfig = DEFAULT,
	resources = null
) => {
	const priceHasDecimal = priceValue % 1 != 0;
	let roundedPrice = null;
	const priceIsZero = priceValue === 0;
	if (priceIsZero) {
		roundedPrice =
			priceConfig.zero == ZERO_CROSS &&
			resources &&
			resources[resourceKeys.ZERO_PRICE]
				? resources[resourceKeys.ZERO_PRICE]
				: priceConfig.zero;
	} else if (priceHasDecimal) {
		roundedPrice = priceValue.toLocaleString("pt-PT", {
			minimumFractionDigits: priceConfig.decimals,
			maximumFractionDigits: priceConfig.decimals
		});
		// roundedPrice = priceValue.toFixed(priceConfig.decimals);
		// if (priceConfig.decimalSeparator != DEFAULT_ECMA_DECIMAL_SEPARATOR) {
		//    roundedPrice = lodash.replace(roundedPrice, DEFAULT_ECMA_DECIMAL_SEPARATOR, priceConfig.decimalSeparator);
		// }
	} else {
		roundedPrice = priceValue.toLocaleString("pt-PT", {
			minimumFractionDigits: priceConfig.noDecimals,
			maximumFractionDigits: priceConfig.decimals
		});
	}

	return roundedPrice;
};

// id(pin): "b30ac842-9758-4b3a-9c72-f9b159630979"
// title(pin): "Apple iPhone 6 64GB"
// price(pin): 0
// monthlyPrice(pin): 0
// category(pin): "Smartphones"
// brand(pin): "Apple"
// loyaltyPeriod(pin): 0
// campaignValue(pin): 0
// campaignMonthlyValue(pin): 0
// months(pin): 0
// points(pin): 0
// url(pin): "/Configuracao-equipamentos"
// plan(pin): null
// innerOffers(pin): innerOffersWithPrice(pin):
// totalPrice(pin): 0
// totalMonthlyPrice(pin): 0
// isPromotionalDefault(pin): false
// stampStyles(pin): stampTexts(pin): counters(pin): promotionalZone1(pin): promotionalZone2(pin): promotionalZone3(pin): promotionalZone4(pin): promotionalNotes(pin): promotionalValueTexts(pin): configurationTexts(pin): configurationInstallmentValues(pin):
// stampText(pin): ""
// stampStyle(pin): ""
// sapCode(pin): "2000006774"
// purchaseMode(pin): "promptPayment"
// image(pin): "http://isites-suporte-webapp.telecom.pt/suporte/catalogoofertasconsumo/UCMImages/isell/equipamentos_moveis/iphone/iphone_6/iphone_6_detalhe_branco.png"

export const hasDiscount = (priceOffer) => priceOffer.promotionalValueTexts;

export const getDiscount = (priceOffer, prefix = "") => {
	const discount = hasDiscount(priceOffer)
		? priceOffer.promotionalValueTexts[0]
		: null;
	let discountText = "";
	if (discount && discount.item2 > 0) {
		discountText = prefix + getFormattedRoundedPrice(discount.item2);
	}
	return discount ? `${discountText} ${discount.item1}` : null;
};

export const getDiscountText = (discount, discountValue, prefix) => {
	let discountText = null;
	if (!discount || !discount.item1) {
		return discountText;
	}
	discountText = "";
	if (discountValue && discountValue > 0) {
		discountText = prefix + getFormattedRoundedPrice(discountValue);
	}
};

export const getDiscountValue = (priceOffer) => {
	const discount = hasDiscount(priceOffer)
		? priceOffer.promotionalValueTexts[0]
		: null;
	return discount ? discount.item2 : null;
};

export const getInstallmentsDiscount = (
	priceOffer,
	{ resource, prefix } = {
		resource: null,
		prefix: ""
	}
) => {
	const totalPromo = getTotalPromo(priceOffer, resource);
	const months = priceOffer.months;
	const totalPromoValue = computeTotalPromoValue(totalPromo, months);
	let promoText = "";
	if (totalPromoValue && totalPromoValue > 0) {
		promoText = prefix + getFormattedRoundedPrice(totalPromoValue);
	}
	return totalPromo && totalPromo.item1
		? `${promoText} ${totalPromo.item1}`
		: null;
};

export const getInstallmentsDiscountValue = (
	priceOffer,
	promptPaymentValue
) => {
	const { campaignValue, campaignMonthlyValue, months } = priceOffer;
	const discountValue =
		promptPaymentValue - (campaignValue + campaignMonthlyValue * months);
	return discountValue > 0 ? discountValue : null;
};

export const sumPromoValue = (previousValue, promo) => {
	const sumValue = {
		item1: getNewPromoText(previousValue.item1, promo.item1),
		item2: getNewPromoValue(previousValue.item2, promo.item2),
		item3: getNewPromoValue(previousValue.item3, promo.item3)
	};

	return sumValue;
};

export const getNewPromoText = (previousText, text) => {
	if (previousText) {
		return previousText;
	}
	if (text) {
		return text;
	}
	return null;
};

export const getNewPromoValue = (previous, newValue) => {
	if (newValue) {
		if (previous) {
			return previous + newValue;
		}

		return newValue;
	}
	return previous;
};

export const getConfigurationInstallmentValue = (priceOffer) => {
	let value = null;
	if (priceOffer && priceOffer.configurationInstallmentValues) {
		const configurationValue = priceOffer.configurationInstallmentValues;
		if (configurationValue && lodash.isArray(configurationValue)) {
			if (configurationValue.length > 0) {
				value = configurationValue[0];
			}
		} else {
			value = lodash.isNumber(configurationValue) ? configurationValue : null;
		}
	}
	return value;
};

export const hasConfigurationInstallmentValue = (priceOffer) => {
	return !!getConfigurationInstallmentValue(priceOffer);
};

export const getTotalPromo = (
	priceOffer,
	resourceDiscountPhrase = "undefined discount phrase"
) => {
	/* 
    item1: promotional text, 
    item2: first installment discount, 
    item3: installments discount
*/
	let totalPromo = {
		item1: null,
		item2: null,
		item3: null
	};

	const configurationValue = getConfigurationInstallmentValue(priceOffer);
	if (configurationValue) {
		totalPromo = {
			item1: resourceDiscountPhrase,
			item2: configurationValue,
			item3: ZERO_PER_MONTH
		};
	} else {
		const { promotionalValueTexts } = priceOffer;
		if (promotionalValueTexts) {
			for (const promo of promotionalValueTexts) {
				if (promo) {
					totalPromo = sumPromoValue(totalPromo, promo);
				}
			}
		}
	}

	return totalPromo;
};

export const computeTotalPromoValue = (totalPromo, months = 0) => {
	/* 
        item1: promotional text, 
        item2: first installment discount, 
        item3: installments discount
    */

	const firstInstallment = totalPromo.item2 ? totalPromo.item2 : 0;
	const installmentsDiscount = totalPromo.item3 ? totalPromo.item3 : 0;

	return firstInstallment + months * installmentsDiscount;
};

export const getTotalDiscount = (priceOffer, resourceDiscountPhrase) => {
	return getTotalPromo(priceOffer, resourceDiscountPhrase);
};

export const getTotalDiscountValue = (priceOffer, resourceDiscountPhrase) => {
	return computeTotalPromoValue(
		getTotalDiscount(priceOffer, resourceDiscountPhrase),
		priceOffer.months
	);
};

export const getOrderValue = (purchaseModeGroup, priceOffer) => {
	switch (purchaseModeGroup) {
		case offerPriceRelEnum.PromptPayment:
		case purchaseModes.PROMPT_PAYMENT:
			return priceOffer.campaignValue;
		case offerPriceRelEnum.Installments:
		case purchaseModes.INSTALLMENTS:
			return priceOffer.totalMonthlyPrice;
		case offerPriceRelEnum.Points:
		case purchaseModes.POINTS:
			return priceOffer.points;
		case offerPriceRelEnum.Fidelizations:
		case purchaseModes.FIDELIZATIONS:
			return priceOffer.campaignValue;
		default:
			return null;
	}
};

const getMinPriceOfferByPurchaseModeGroup = (
	purchaseModeGroup,
	priceOffers
) => {
	switch (purchaseModeGroup) {
		case purchaseModes.PROMPT_PAYMENT:
		case purchaseModes.INSTALLMENTS:
		case purchaseModes.POINTS:
		case purchaseModes.FIDELIZATIONS:
			return lodash.minBy(priceOffers, (priceOffer) =>
				getOrderValue(purchaseModeGroup, priceOffer)
			);
		default:
			return null;
	}
};

export const getMinPriceOffer = (purchaseModeOffer, priceOffers) => {
	const purchaseModeGroup = purchaseModeOffer.getPurchaseModeGroup();
	return getMinPriceOfferByPurchaseModeGroup(purchaseModeGroup, priceOffers);
};

export const getMinPriceOfferForGroup = (purchaseModeGroup, minPriceOffers) => {
	const purchaseModesArray = purchaseModeGrouping[purchaseModeGroup];
	let concatenated = [];
	const pmExample = purchaseModesArray[0];
	const pmo = new PurchaseModeOffer({ purchaseMode: pmExample });
	for (const pm of purchaseModesArray) {
		const purchaseModeMinOffers =
			minPriceOffers[
				PurchaseModeOffer.findMatchingPurchaseModeOfferId(
					pm,
					Object.keys(minPriceOffers)
				)
			];

		if (purchaseModeMinOffers) {
			concatenated = concatenated.concat(purchaseModeMinOffers);
		}
	}
	return getMinPriceOffer(pmo, concatenated);
};

export const getOfferMinPriceOffersByPurchaseMode = (
	entityObj,
	purchaseModeOffers,
	offerPurchaseModeIds,
	filter = null
) => {
	const result = {};
	for (const pm of offerPurchaseModeIds) {
		const purchaseModeOffer = purchaseModeOffers.byId[pm];
		if (purchaseModeOffer && purchaseModeOffer.priceOffers) {
			const purchaseModeOfferObj = new PurchaseModeOffer(purchaseModeOffer);

			result[pm] = getMinPriceOffer(
				purchaseModeOfferObj,
				getPriceOffersByIds(
					entityObj.byId,
					purchaseModeOfferObj.priceOffers,
					(filter = null)
				)
			);
		}
	}
	return result;
};

export const getPriceOffersByIds = (
	entityObj,
	priceOfferIdsArray,
	filter = null
) => {
	return priceOfferIdsArray.map((id, i) => entityObj[id]);
};

export const getOfferPriceOffersByPurchaseMode = (
	entityObj,
	purchaseModeOffers,
	offerPurchaseModeIds,
	filter = null
) => {
	const result = {};
	for (const pm of offerPurchaseModeIds) {
		const purchaseModeOffer = purchaseModeOffers.byId[pm];
		if (purchaseModeOffer && purchaseModeOffer.priceOffers) {
			const purchaseModeOfferObj = new PurchaseModeOffer(purchaseModeOffer);
			result[pm] = getPriceOffersByIds(
				entityObj.byId,
				purchaseModeOfferObj.priceOffers,
				(filter = null)
			);
		}
	}
	return result;
};

export const getNumberOfValidPurchaseModesForGroup = (
	purchaseModeGroup,
	priceOffersArray
) => {
	const purchaseModesArray = purchaseModeGrouping[purchaseModeGroup];
	let counter = 0;
	for (const pm of purchaseModesArray) {
		const purchaseModeOfferId = PurchaseModeOffer.findMatchingPurchaseModeOfferId(
			pm,
			priceOffersArray
		);
		if (purchaseModeOfferId) {
			counter++;
		}
	}
	return counter;
};

export const isValidPreviousPrice = (previousPrice, price) => {
	return !!(previousPrice && previousPrice != price && previousPrice != 0);
};

export const getFidelizationPlan = (priceOffer) => {
	let plan = null;
	const standardFidelizationPlan = priceOffer.plan;
	if (standardFidelizationPlan) {
		plan = standardFidelizationPlan;
	} else {
		// Equipment + Tariff case (no price sent as of this day)
		// const innerOffers = priceOffer.innerOffers;
		// if (innerOffers && innerOffers.length > 0) {
		//     const tariffInnerOffers = lodash.filter(
		//         innerOffers,
		//         (innerOffer) => {
		//             return lodash.includes(
		//                 lodash.lowerCase(innerOffer.title),
		//                 lodash.lowerCase(TARIFF_TITLE_IDENTIFIER)
		//             );
		//         });
		//     if (tariffInnerOffers && tariffInnerOffers.length > 0) {
		//         plan = tariffInnerOffers[0];
		//     }
		// }
	}
	return plan;
};

export const isAllOffersHaveSamePrice = (groupOffersTree, group) => {
	let isAllOffersHaveSamePrice = true;
	if (groupOffersTree && groupOffersTree.length > 0) {
		const firstElementValue = getOrderValue(group, groupOffersTree[0]);
		isAllOffersHaveSamePrice = lodash.every(
			groupOffersTree,
			(value) => getOrderValue(group, value) == firstElementValue
		);
	}
	return isAllOffersHaveSamePrice;
};
